// import { GetCategoryDataSummaryHttpRequest } from "../../repsaApi";
import {
  AggregationTypesEnum,
  BusinessPlanningCategoryType,
  FinancialCategoryEnumModel,
} from "../../../types/types";
import { AggregationTypes, FinancialCategoryEnum } from "../../repsaApi";
import api, * as analyticsApi from "./analyticsApi";
import {
  getCategoryDataSummaryFulfilled,
  getCategoryDataSummaryPending,
  getCategoryDataSummaryRejected,
  getFinCategoryDataSummaryFulfilled,
  getFinCategoryDataSummaryPending,
  getFinCategoryDataSummaryRejected,
  getBusinessPlanningDataPending,
  getBusinessPlanningDataFulfilled,
  getBusinessPlanningDataRejected,
  getBusinessZonesDataPending,
  getBusinessZonesDataFulfilled,
  getBusinessZonesDataRejected,
} from "./analyticsStateActions";

export function getCategoryDataSummary(
  yearsIds: number[],
  category: string,
  typesIds: number[] | undefined,
  coAgentIds?: number[],
  includeUnderContracts: boolean = false,
) {
  return function (dispatch: any) {
    dispatch(getCategoryDataSummaryPending(category));
    analyticsApi
      .getCategoryDataSummaryWithFilter(
        category,
        yearsIds,
        typesIds,
        coAgentIds,
        includeUnderContracts,
      )
      .then(
        (response) => {
          dispatch(
            getCategoryDataSummaryFulfilled({
              categoryId: category,
              data: response,
            }),
          );
        },
        (error) => dispatch(getCategoryDataSummaryRejected(error.message)),
      );
  };
  // return api.getCategoryDataSummary(request);
}

export function getFinancialCategoryDataSummary(
  yearIds: number[] | undefined,
  category: FinancialCategoryEnumModel,
  coAgentIds?: number[],
) {
  return function (dispatch: any) {
    dispatch(getFinCategoryDataSummaryPending(category));
    analyticsApi
      .getFinancialCategoryDataSummaryWithFilter(
        category as unknown as string,
        yearIds,
        coAgentIds,
      )
      .then(
        (response) => {
          dispatch(
            getFinCategoryDataSummaryFulfilled({
              categoryId: category,
              data: response,
            }),
          );
        },
        (error) =>
          dispatch(
            getFinCategoryDataSummaryRejected({
              categoryId: category,
              error: error.message,
            }),
          ),
      );
  };
}
export function getAggregateDataSummary(
  yearIds: number[],
  typesIds: number[],
  aggregateType: AggregationTypesEnum,
  coAgentIds?: number[],
  includeUnderContracts: boolean = false,
) {
  // return function (dispatch: any) {
  //   console.warn(
  //     "getAggregateDataSummary called with yearId:",
  //     yearId,
  //     "and aggregateType:",
  //     aggregateType.toString()
  //   );
  // dispatch(getAggregateDataSummaryPending(aggregateType.toString()));
  return api.getAggregateDataSummary(
    aggregateType === AggregationTypesEnum.Average
      ? AggregationTypes.Average
      : AggregationTypes.Total,
    yearIds,
    typesIds,
    coAgentIds,
    includeUnderContracts,
  );
  // .then(
  //   (response) => {
  //     dispatch(
  //       getAggregateDataSummaryFulfilled({
  //         categoryId: "aggregate",
  //         data: response,
  //       })
  //     );
  //   },
  //   (error) => dispatch(getAggregateDataSummaryRejected(error.message))
  // );
  // };
}

export function getBusinessPlanningData(
  yearIds: number[],
  forecastYear: "thisYear" | "nextYear",
  categories: BusinessPlanningCategoryType[],
  onlySb: boolean = true,
  coAgentIds?: number[],
) {
  return function (dispatch: any) {
    dispatch(getBusinessPlanningDataPending());
    analyticsApi
      .getBusinessPlanningData(
        yearIds,
        forecastYear,
        categories,
        onlySb,
        coAgentIds,
      )
      .then(
        (response) => {
          dispatch(getBusinessPlanningDataFulfilled(response));
        },
        (error) => dispatch(getBusinessPlanningDataRejected(error.message)),
      );
  };
}

export function getBusinessZonesData(
  yearIds: number[],
  greenThreshold: number,
  yellowThreshold: number,
  zoneMetric: string,
) {
  return function (dispatch: any) {
    dispatch(getBusinessZonesDataPending());
    analyticsApi
      .getBusinessZonesData(
        yearIds,
        greenThreshold,
        yellowThreshold,
        zoneMetric,
      )
      .then(
        (response) => {
          dispatch(getBusinessZonesDataFulfilled(response));
        },
        (error: any) => dispatch(getBusinessZonesDataRejected(error.message)),
      );
  };
}
